import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { shouldShowError } from 'helpers/page-utils';
import _range from 'lodash/range';
import { reduxFormPropTypes, intlMessage } from 'constants/propTypes';
import { isMessage } from 'helpers/intl-fns';
import BaseGrowingTextarea from '../../GrowingTextarea';
import InputError from '../InputError/InputError';

const GrowingTextarea = forwardRef((props, ref) => {
  const intl = useIntl();
  const { input, meta, placeholder = '', ...restInputProps } = props;
  const { name } = input;
  const commonProps = {
    ref,
    id: name,
    ...input,
    ...restInputProps,
    hasError: shouldShowError(meta),
    placeholder: isMessage(placeholder) ? intl.formatMessage(placeholder) : placeholder,
  };

  return (
    <>
      <BaseGrowingTextarea {...commonProps} />
      <InputError {...meta} />
    </>
  );
});

GrowingTextarea.propTypes = {
  className: PropTypes.string,
  heightInLines: PropTypes.oneOf(_range(2, 11)),
  input: reduxFormPropTypes.field.input,
  meta: reduxFormPropTypes.field.meta,
  placeholder: PropTypes.oneOfType([PropTypes.string, intlMessage]),
};

GrowingTextarea.displayName = 'GrowingTextarea';

export default GrowingTextarea;
